import i18n from './i18n'
import css from './index.module.css'

import { Config } from '#/global/helper/Config'

interface Props {
    points: number
}
export const SeasonPoints = ({ points }: Props) => {
    const t = i18n[Config.getLang()].seasonPoints

    return (
        <div className={`r-info-box-season-point ${css.container}`}>
            <div className={`${css.content} ${css.seasonPoints}`}>
                <div className={css.icon}>
                    <img src="https://cdn1.idek.cz/file/plus-white-a6e119fe.svg" width={24} height={24} />
                </div>
                <div className={css.text}>
                    <b>{t.title}</b>
                    <span className={css.subText}>{t.text}</span>
                </div>
                <div className={css.points}>
                    <div>
                        <b>{points}</b>
                        {' '}
                        b.
                    </div>
                </div>
            </div>
        </div>
    )
}
